import {api} from 'services/api';
import {ObjectId} from 'types/object-id';
import {ResponseData} from 'types/response-data';

const projectSellsFFEExport = api.injectEndpoints({
  endpoints: builder => ({
    projectSellsFFEExport: builder.query<Response, Request>({
      query: params => {
        return {
          method: 'GET',
          url: `projects/${params.id}/export-ffe`,
        };
      },
    }),
  }),
});

type Request = {
  id?: ObjectId;
};

type Response = ResponseData<{
  download_link: string;
  document_name: string;
}>;

export const {useLazyProjectSellsFFEExportQuery} = projectSellsFFEExport;
